// @flow strict
export default class MasonryLayout {}
